import get from 'lodash/get'

export const getNumberOfWebcastsInFirstMonth = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'maxCommunicationsFirstMonth' && enabled === true)
  if (!enabledFeature) {

    const disabledFeature = channelData.features.find(({ name, enabled }) => name === 'maxCommunicationsFirstMonth' && enabled === false)

    if (disabledFeature) {

        return 'Unlimited'

    } else {

        return false

    }

  }

  return enabledFeature.value

}
